import { resetLink } from '@/services/userService/users-api';
import store from '@/store';
import {
  getModule,
  Module,
  VuexModule,
  MutationAction
} from 'vuex-module-decorators';
import { ForgotPasswordResponse } from '@/Model/model';

@Module({
  namespaced: true,
  name: 'forgotPass',
  store,
  dynamic: true
})
class ForgotPasswordModule extends VuexModule {
  forgotPassRes: ForgotPasswordResponse | any = {};

  get linkVerification() {
    return this.forgotPassRes;
  }


  @MutationAction
  resetPassLink(payloadObj: any) {
    return resetLink(payloadObj).then((response) => {
      return { forgotPassRes: response };
    }, (error) => {
      return { forgotPassRes: error };
    });
  }
}

export default getModule(ForgotPasswordModule);